import { LoginForm } from '@/features/auth/LoginForm'

export function LoginPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-canvas p-4">
      <LoginForm />
    </main>
  )
}
